function calculateInstallment() {
 // Select the element with data attribute 'data-subtotal'
 const cartSubtotalDiv = document.querySelector(".t4s-cart__totalPrice");
 // Check if the element exists
 if (cartSubtotalDiv) {
   const cartTotalText = cartSubtotalDiv.textContent;
   if (cartTotalText) {
     // Clean the cart total text
     const cleanedCartTotalText = cartTotalText
       .replace(/[^0-9.]/g, "")
       .replace(/^\.+/, "");
     const cartPageTotal = parseFloat(cleanedCartTotalText);
     // Calculate the final cart price
     const finalCartPrice = Math.floor(cartPageTotal / 3);
     const currency = sessionStorage.getItem("currency");
     // Select the element to display the installment price
     const priceDiv = document.querySelector(".alif-price-divide");
     if (priceDiv) {
       priceDiv.textContent = currency + finalCartPrice.toLocaleString();
     }
   }
 }
 // Call the function again after 1 second
 setTimeout(calculateInstallment, 1000);
}
// Initial call to the function
// calculateInstallment();
// function calculateInstallment() {
//   const priceEl = document.querySelector(".t4s-cart__totalPrice");
//   if (!priceEl) return;

//   const raw = priceEl.getAttribute("data-cart-total") || priceEl.textContent;

//   const value = parseFloat(raw.replace(/[^0-9.]/g, ""));

//   if (!value) return;

//   const installment = Math.floor(value / 3);

//   const target = document.querySelector(".alif-price-divide");

//   if (target) {
//     target.textContent = "Rs. " + installment.toLocaleString();
//   }
// }
// // run once only
// // window.addEventListener("load", calculateInstallment);
//   setTimeout(calculateInstallment, 1000);
// function updateInstallment() {
//   const el = document.querySelector(".t4s-cart__totalPrice");
//   const target = document.querySelector(".alif-price-divide");

//   if (!el || !target) return;

//   const value = Number(el.dataset.cartTotal);

//   if (!value || value <= 0) return;

//   const installment = Math.round(value / 3);

//   target.textContent = "Rs. " + installment.toLocaleString();
// }

// /* run safely after everything loads */
// document.addEventListener("DOMContentLoaded", function () {
//   updateInstallment();

//   /* Shopify cart updates happen after clicks */
//   document.body.addEventListener("click", function () {
//     setTimeout(updateInstallment, 300);
//     setTimeout(updateInstallment, 800);
//   });
// });
